import type { ElementType, ReactNode } from "react";
import Title from "./Title";
import Text from "./Text";
import FeaturedIcon from "./FeaturedIcon";
import styles from "./EmptyState.module.css";

interface EmptyStateProps {
  icon: ElementType;
  title: string;
  description?: ReactNode;
  children?: ReactNode;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  children,
}: EmptyStateProps) {
  return (
    <div className={styles.container}>
      <FeaturedIcon icon={Icon} size="lg" className={styles.icon} />
      <Title variant="hecto" weight="bold" as="h2">
        {title}
      </Title>
      {description && (
        <Text color="muted" className={styles.description}>
          {description}
        </Text>
      )}
      {children && <div className={styles.actions}>{children}</div>}
    </div>
  );
}
